/**
 * 번역 도구가 화면 구조를 바꿔도 React 가 죽지 않게 하는 방어 코드 (2026-10-09)
 *
 * 무슨 일이 있었나
 * 배송 상세 등에서 화면이 통째로 사라졌다(베트남·태국 KOL 팀 신고). 오류 안내 화면(오류 경계)에 찍힌 내용:
 *   NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
 * 번역 도구(Weglot, 브라우저 자동 번역)는 글자 칸을 다른 태그로 감싸거나 옮긴다. React 는 그 사실을 모른 채
 * 원래 자리에서 노드를 지우려다(removeChild) 못 찾아 예외를 던지고, 그 예외가 화면 전체를 지운다.
 * 줄이 많은 표(배송지 33줄 등)에서 먼저 터진다.
 *
 * 무엇을 하나
 * 부모의 자식이 아닌 노드를 지우거나(removeChild), 부모의 자식이 아닌 기준 노드 앞에 넣으려 하면(insertBefore)
 * 예외 대신 «건너뛴다». 정상일 때는 원래 동작 그대로다. (React 커뮤니티에서 널리 쓰는 방어책 — facebook/react#11538)
 * 번역이 어긋난 칸은 일부 글자가 번역·갱신되지 않을 수 있지만, 화면 전체가 사라지는 것보다 낫다.
 *
 * 한 번만 설치된다(여러 번 불러도 안전).
 */
let installed = false;
const warned = new Set();

const warnOnce = (kind) => {
  if (warned.has(kind)) return;
  warned.add(kind);
  try { console.warn(`[domTranslationGuard] ${kind}: 부모의 자식이 아닌 노드라 건너뜁니다(번역 도구가 화면 구조를 바꾼 것으로 보임)`); } catch (e) { /* 무시 */ }
};

export function installDomTranslationGuard() {
  if (installed || typeof Node === 'undefined' || !Node.prototype) return false;
  installed = true;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChildGuarded(child) {
    if (child && child.parentNode !== this) {
      warnOnce('removeChild');
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBeforeGuarded(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      warnOnce('insertBefore');
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };

  return true;
}

/** 시험용 — 설치 상태를 되돌린다(원래 함수는 복구하지 않는다) */
export function __resetDomTranslationGuardForTest() {
  installed = false;
  warned.clear();
}
